// ===================================================================
// Modo prova: redireciona páginas incompatíveis com o processo selecionado
// ===================================================================

import React, { useEffect } from 'react';
import { useAdminProcess } from '../../contexts/AdminProcessContext';
import { GLOBAL_MENU_PAGE_IDS } from './Navigation';

const EXAM_PHASE_PAGES = ['exam-objective', 'exam-essay'];

function adminFallbackPage(sel, leavingPage) {
  if (leavingPage === 'exam-essay' && sel?.exam_uses_answer_sheet) return 'exam-objective';
  if (leavingPage === 'exam-objective' && sel?.exam_uses_essay) return 'exam-essay';
  return 'painel';
}

function analystDefaultPage(sel) {
  if (!sel) return 'painel';
  if (sel.has_fee) return 'analyst-exemptions';
  if (sel.selection_mode === 'prova') {
    if (sel.exam_uses_answer_sheet) return 'exam-objective';
    if (sel.exam_uses_essay) return 'exam-essay';
    if (sel.use_special_attendance_specialized || sel.use_special_attendance_specific) {
      return 'analyst-special-attendance';
    }
    return 'analyst-resources';
  }
  return 'analyst-applications';
}

function analystFallbackPage(sel, leavingPage) {
  if (leavingPage === 'exam-essay' && sel?.exam_uses_answer_sheet) return 'exam-objective';
  if (leavingPage === 'exam-objective' && sel?.exam_uses_essay) return 'exam-essay';
  return analystDefaultPage(sel);
}

export const Phase0NavGuard = React.memo(({ currentPage, setCurrentPage, userRole }) => {
  const { processes, selectedProcessId, isLoadingProcesses } = useAdminProcess();

  useEffect(() => {
    if (GLOBAL_MENU_PAGE_IDS.includes(currentPage)) return;
    if (isLoadingProcesses || !['admin', 'analyst'].includes(userRole || '')) return;
    const sel = processes.find((p) => String(p.id) === String(selectedProcessId));
    if (!sel) {
      if (userRole === 'admin' && currentPage === 'payments') {
        setCurrentPage('painel');
      }
      return;
    }

    if (userRole === 'admin' && currentPage === 'payments' && !sel.has_fee) {
      setCurrentPage('painel');
      return;
    }

    if (userRole === 'analyst' && currentPage === 'analyst-exemptions' && !sel.has_fee) {
      setCurrentPage(analystDefaultPage(sel));
      return;
    }

    const isProva = sel.selection_mode === 'prova';
    const hasAnswerSheet = Boolean(sel.exam_uses_answer_sheet);
    const hasEssay = Boolean(sel.exam_uses_essay);

    if (isProva) {
      if (userRole === 'admin' && currentPage === 'analysis') {
        setCurrentPage('painel');
        return;
      }
      if (userRole === 'analyst' && currentPage === 'analyst-applications') {
        setCurrentPage(analystDefaultPage(sel));
        return;
      }
      if (currentPage === 'exam-essay' && !hasEssay) {
        setCurrentPage(
          userRole === 'admin' ? adminFallbackPage(sel, 'exam-essay') : analystFallbackPage(sel, 'exam-essay')
        );
        return;
      }
      if (currentPage === 'exam-objective' && !hasAnswerSheet) {
        setCurrentPage(
          userRole === 'admin'
            ? adminFallbackPage(sel, 'exam-objective')
            : analystFallbackPage(sel, 'exam-objective')
        );
        return;
      }
      if (userRole === 'analyst' && currentPage === 'analyst-exam-grades') {
        setCurrentPage(hasAnswerSheet ? 'exam-objective' : hasEssay ? 'exam-essay' : analystDefaultPage(sel));
        return;
      }
    } else {
      if (
        userRole === 'analyst' &&
        (currentPage === 'analyst-special-attendance' ||
          currentPage === 'analyst-exam-grades' ||
          EXAM_PHASE_PAGES.includes(currentPage))
      ) {
        setCurrentPage(analystDefaultPage(sel));
        return;
      }
      if (userRole === 'admin' && (currentPage === 'admin-special-attendance' || EXAM_PHASE_PAGES.includes(currentPage))) {
        setCurrentPage('painel');
      }
    }
  }, [isLoadingProcesses, processes, selectedProcessId, currentPage, userRole, setCurrentPage]);

  return null;
});
